import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Space, Card } from 'antd';
import Button from 'components/button';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import ServicesList from '../components/ServicesList';
import useServices from '../useServices';

const Main = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    services,
    loading,
    total,
    currentPage,
    pageSize,
    filters,
    filterData,
    updateFilters,
    handlePageChange,
    refetch,
    deleteService,
  } = useServices();

  return (
    <Card
      title={
        <span style={{ fontSize: '24px', fontWeight: '600' }}>
          {t('Servizi')}
        </span>
      }
      extra={
        <Button
          type='primary'
          icon={<PlusOutlined />}
          onClick={() => navigate('create')}
          style={{
            marginBottom: 12,
            width: '140px',
            height: 48,
            backgroundColor: '#002637',
            borderColor: '#002637',
          }}
        >
          {'Nuovo'}
        </Button>
      }
    >
      <ServicesList
        services={services}
        loading={loading}
        total={total}
        currentPage={currentPage}
        pageSize={pageSize}
        filters={filters}
        filterData={filterData}
        onFiltersChange={updateFilters}
        onPageChange={handlePageChange}
        refetch={refetch}
        deleteService={deleteService}
      />
    </Card>
  );
};

export default Main;
